import { format } from 'date-fns'
import {
  DATE_ONLY_PATTERN,
  EMPTY_DATE_PLACEHOLDER,
  UNIX_SECONDS_TO_MS,
} from '../constants/mailLogDates'

/**
 * Mirrors Angular's shared `date` pipe (`DateFilterPipe`), which overrides the built-in
 * `DatePipe`: a real number is Unix *seconds* and is scaled before formatting, while a
 * numeric string is passed straight to `DatePipe` and read as milliseconds. A date-only
 * string is local midnight (plain `new Date('2026-08-07')` is UTC midnight, which renders
 * the previous day in negative-offset zones).
 */
function toAngularDate(value: unknown): Date | null {
  if (value === null || value === undefined || value === '') return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : new Date(value * UNIX_SECONDS_TO_MS)
  }

  const raw = String(value).trim()
  if (!raw) return null

  const numeric = Number.parseFloat(raw)
  if (!Number.isNaN(numeric) && !Number.isNaN(Number(raw))) {
    return new Date(numeric)
  }

  const dateOnly = DATE_ONLY_PATTERN.exec(raw)
  if (dateOnly) {
    return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
  }

  const parsed = new Date(raw)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

export function formatMailLogDate(value: unknown, pattern: string): string {
  if (value === null || value === undefined || value === '') return EMPTY_DATE_PLACEHOLDER
  const date = toAngularDate(value)
  return date ? format(date, pattern) : String(value)
}
